import { TILE_LIBRARY_TYPES } from '../../../state/map/tiles/constants';
import HereRoutes from './HereRoutes';
import LeafletRoutes from './LeafletRoutes';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [TILE_LIBRARY_TYPES.LEAFLET]: LeafletRoutes,
  [TILE_LIBRARY_TYPES.JSLA]: HereRoutes,
};
